import { TUser } from '@typings'

/** Build link/deep link that will be navigate to user profile. */
export default function makeUserDeepLink(userId: TUser['id']): string {
	return `https://littleblackdoor.io/profile/${userId}`
}
